import { render, staticRenderFns } from "./CreateArticuloAdmin.vue?vue&type=template&id=d6fad840&scoped=true&"
import script from "./CreateArticuloAdmin.vue?vue&type=script&lang=js&"
export * from "./CreateArticuloAdmin.vue?vue&type=script&lang=js&"
import style0 from "./CreateArticuloAdmin.vue?vue&type=style&index=0&id=d6fad840&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6fad840",
  null
  
)

export default component.exports